import styled from 'styled-components';

export const BlogsHero = styled.section`
  background-color: #1f1f1f;
  color: #fff;
  .loader {
    width: 100%;
    /* width: calc(54% + 136px); */
    aspect-ratio: 2 / 0.721;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .flex-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 68px 0;
  }

  .image {
    position: relative;
    width: 54%;
    aspect-ratio: 2 / 0.97;
  }

  .main {
    width: calc(46% - 80px);
    > * {
      max-width: 464px;
    }
    .category {
      display: flex;
      flex-wrap: wrap;
      a {
        line-height: 32px;
        padding: 0 12px;
        background-color: var(--primary);
        color: #000;
        font-size: 12px;
        border-radius: 6px;
        display: inline-block;
        margin-bottom: 16px;
        margin-right: 4px;
      }
    }
    .title a {
      display: block;
      font-size: 36px;
      font-weight: 800;
      margin-bottom: 8px;
    }
    p {
      font-size: 16px;
      margin-bottom: 24px;
    }
    .date {
      border-top: 1px solid #eceff11a;
      padding-top: 24px;
      max-width: unset;
    }
  }
  @media screen and (max-width: 1240px) {
    .flex-wrap {
      padding: 48px 0;
    }
    .image {
      width: 52%;
      min-height: 280px;
    }

    .main {
      width: calc(48% - 44px);
      .title  a{
        font-size: 24px;
      }
    }
  }
  @media screen and (max-width: 960px) {
    .flex-wrap {
      padding: 24px 0 32px;
    }
    .loader {
      height: 400px;
    }
    .image {
      width: 100%;
      min-height: unset;
      margin: 0 0 32px;
    }

    .main {
      width: 100%;
    }
  }
  @media screen and (max-width: 740px) {
    .flex-wrap {
      padding: 0 0 32px;
    }
    .loader {
      height: 400px;
    }
    .image {
      width: calc(100% + 32px);
      min-height: unset;
      margin: 0 -16px 32px;
    }
    .main .date {
      font-size: 12px;
    }
  }
`;

export const BlogsPreview = styled.section`
  margin-top: 64px;
  margin-bottom: 80px;
  .tags {
    display: flex;
    flex-wrap: wrap;
    button {
      height: 52px;
      display: flex;
      align-items: center;
      padding: 0 12px 0 16px;
      background-color: #F5F6F9;
      border-radius: 24px;
      font-size: 16px;
      margin-bottom: 8px;
      margin-right: 8px;
      :last-of-type {
        margin-bottom: 20px;
      }
      span {
        margin-left: 12px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #E3E3E3;
        svg {
          height: 9px;
        }
      }
    }
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    row-gap: 44px;
    column-gap: 32px;
    > div:nth-of-type(3),
    > div:nth-of-type(4) {
      grid-column: span 2;
    }
  }
  @media screen and (max-width: 1160px) {
    .grid {
      row-gap: 32px;
      column-gap: 24px;
    }
  }
  @media screen and (max-width: 860px) {
    .grid {
      grid-template-columns:  1fr 1fr;
      width: 100%;
      > div:nth-of-type(3) {
        order: -1;
      }
      > div {
        min-width: 100px;
        min-height: 100px
      }
    }
  }
  @media screen and (max-width: 740px) {
    margin: 36px 0 60px;
    .tags button {
      padding: 0 12px;
      font-size: 14px;
      height: 48px;
      border-radius: 20px;
      :last-of-type {
        margin-bottom: 24px;
      }
    }
    .grid {
      > div:nth-of-type(3),
      > div:nth-of-type(4) {
        .image {
          height: 188px;
        }
        .main a {min-height: unset;}
      }
    }
  }
`;

export const BlogsCard = styled.div`
  display: flex;
  flex-direction: column;
  .image {
    position: relative;
    width: 100%;
    height: 188px;
    display: block;
    .category {
      z-index: 5;
      position: absolute;
      bottom: 20px;
      left: 16px;
      display: flex;
      flex-wrap: wrap;
      a {
        background-color: var(--primary);
        padding: 0 12px;
        font-size: 12px;
        line-height: 32px;
        border-radius: 5px;
        margin-right: 4px;
      }
    }
  }

  .main {
    padding: 16px 8px;
    flex: 1;
    display: flex;
    flex-direction: column;
    a {
      font-size: 16px;
      font-weight: 800;
      margin-bottom: 10px;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      transition: 0.4s;
      min-height: 42px;
      :hover {
        color: var(--hyperlink);
      }
    }
    p {
      font-size: 14px;
      line-height: 1.7;
      margin-bottom: 24px;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .date {
      margin-top: auto;
      font-size: 12px;
      .mob {
        display: none;
      }
    }
  }
  @media screen and (max-width: 740px) {
    .image {
      height: 144px;
      .category {
        bottom: 12px;
        left: 8px;
      }
    }
    .main {
      p {
        margin-bottom: 12px;
        -webkit-line-clamp: 2;
      }
      .date {
        .mob {
          display: inline;
        }
        .desc {
          display: none;
        }
      }
    }
  }
`;
export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 52px;

  button,
  .dots {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    margin: 0 8px;
    font-size: 14px;
    transition: all.4s ease-in-out;
    @media (hover: hover) and (pointer: fine) {
      :not(.dots, [disabled]):hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }

  .arr {
    margin: 0 12px;
    &[disabled],
    :disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background-color: #fff;
    }
  }
  .number {
    &.active {
      background-color: #000 !important;
      color: #fff;
    }
  }

  .dots {
    line-height: 1;
  }
  @media screen and (max-width: 740px) {
    button,
    .dots {
      margin: 0 6px;
    }
  }
`;

export const NoBlogs = styled.div`
  min-height: 600px;
  min-height: 400px;
  margin-bottom: 32px;
  display: flex;
  .main {
    margin: auto;
    max-width: 364px;
    text-align: center;
    svg {
      margin: 0 auto;
    }
    .headline {
      font-size: 18px;
      font-weight: 700;
      margin: 32px 0 8px;
    }
    p {
      font-size: 14px;
      line-height: 1.7;
    }
  }
  @media screen and (max-width: 960px) {
    min-height: 300px;
  }
  @media screen and (max-width: 740px) {
    min-height: 260px;
    padding: 24px 0;
    .main {
      svg {
        width: 80px;
      }
      .headline {
        font-size: 16px;
        margin: 20px 0 8px;
      }
    }
  }
`;
